module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gc-order-detail-with-actions', {
    attrs: {
      "show-place-holder": _vm.emkt.leaveSpaceForFullScreen,
      "show-product-contract-no": false
    },
    scopedSlots: _vm._u([{
      key: "addressOperation",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'WeappAddress',
              params: {
                order: orderDetail,
                addressType: 1
              },
            }
          }
        }, [_c('div', {
          staticClass: "update-address update-address-color"
        }, [_vm._v("修改")])])]
      }
    }, {
      key: "productOperations",
      fn: function(ref) {
        var item = ref.item;
        var orderDetail = ref.orderDetail;

        return [(_vm.showAmplificationBtn(item, orderDetail) && item.name !== '实物返还') ? _c('div', {
          staticClass: "pay-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.amplifyProduct(item, orderDetail)
            }
          }
        }, [_vm._v("\n        我要扩增\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showBuyAgainBtn(item, orderDetail)) ? _c('div', {
          staticClass: "pay-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.buyProductAgain(item, orderDetail)
            }
          }
        }, [_vm._v("\n        再次购买\n      ")]) : _vm._e()]
      }
    }, {
      key: "orderOperations",
      fn: function(ref) {
        var orderDetail = ref.orderDetail;

        return [(_vm.showCancelButton(orderDetail)) ? _c('div', {
          staticClass: "cancel-btn research-font-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderCancel(orderDetail)
            }
          }
        }, [_vm._v("\n        取消订单\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showInvoiceBtn(orderDetail)) ? _c('div', {
          staticClass: "cancel-btn research-font-color",
          on: {
            "click": function($event) {
              return _vm.toPayInvoice(orderDetail)
            }
          }
        }, [_vm._v("\n        查看发票\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showContractBtn(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.toSendContract(orderDetail)
            }
          }
        }, [_vm._v("\n        下载合同\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSampleDeliveryGuideBtn(orderDetail)) ? _c('div', {
          staticClass: "research-background-color",
          class: orderDetail.fromEmkt ? 'submit-btn' : 'sf-sampleGuid-btn',
          on: {
            "click": function($event) {
              return _vm.toSampleDeliveryList(_vm.orderMaterialInfo)
            }
          }
        }, [_vm._v("\n        寄送实物\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitOrderButton(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderSubmit(orderDetail)
            }
          }
        }, [_vm._v("\n        提交订单\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSubmitToCheckSignApproveButton(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderToCheckSignApprove(orderDetail)
            }
          }
        }, [_vm._v("\n        重新提交\n      ")]) : _vm._e(), _vm._v(" "), (_vm.showSignSubmitOrderButton(orderDetail)) ? _c('div', {
          staticClass: "submit-btn research-background-color",
          on: {
            "click": function($event) {
              return _vm.handleOrderToSign(orderDetail)
            }
          }
        }, [_vm._v("\n        签署合同\n      ")]) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-350bd142","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/User/myOrders/OrderDetailPage.vue
// module id = 1597
// module chunks = 8